var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberNineFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberNineFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23 12C23 14.9174 21.8411 17.7153 19.7782 19.7782C17.7153 21.8411 14.9174 23 12 23C9.08262 23 6.28473 21.8411 4.22183 19.7782C2.15893 17.7153 1 14.9174 1 12C1 9.08262 2.15893 6.28473 4.22183 4.22183C6.28473 2.15893 9.08262 1 12 1C14.9174 1 17.7153 2.15893 19.7782 4.22183C21.8411 6.28473 23 9.08262 23 12ZM11.2143 11.4107H12.7857C13.1504 11.4107 13.5001 11.2658 13.758 11.008C14.0158 10.7501 14.1607 10.4004 14.1607 10.0357V9.64286C14.1607 9.27818 14.0158 8.92845 13.758 8.67058C13.5001 8.41272 13.1504 8.26786 12.7857 8.26786H11.2143C10.8496 8.26786 10.4999 8.41272 10.242 8.67058C9.98415 8.92845 9.83929 9.27818 9.83929 9.64286V10.0357C9.83929 10.7947 10.4553 11.4107 11.2143 11.4107ZM12.7857 13.375H11.2143C10.3287 13.375 9.47929 13.0232 8.85305 12.3969C8.22682 11.7707 7.875 10.9213 7.875 10.0357V9.64286C7.875 7.798 9.36943 6.30357 11.2143 6.30357H12.7857C13.6713 6.30357 14.5207 6.65539 15.1469 7.28163C15.7732 7.90786 16.125 8.75722 16.125 9.64286V14.3571C16.125 15.2428 15.7732 16.0921 15.1469 16.7184C14.5207 17.3446 13.6713 17.6964 12.7857 17.6964H11.2143C10.5236 17.6963 9.8499 17.4822 9.28594 17.0834C8.72198 16.6846 8.29548 16.1209 8.06514 15.4697C7.97845 15.224 7.99292 14.954 8.10534 14.7189C8.21777 14.4839 8.41896 14.3032 8.66464 14.2165C8.91033 14.1298 9.18039 14.1443 9.41541 14.2567C9.65043 14.3691 9.83117 14.5703 9.91786 14.816C10.1064 15.3503 10.6171 15.7321 11.2143 15.7321H12.7857C13.1504 15.7321 13.5001 15.5873 13.758 15.3294C14.0158 15.0716 14.1607 14.7218 14.1607 14.3571V13.0796C13.7285 13.2743 13.2598 13.375 12.7857 13.375Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberNineFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberNineFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberNineFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-nine-filled') === undefined) {
    customElements.define('cat-icon-number-nine-filled', BlocksIconNumberNineFilled);
}
